// assets/affiliate-attribution.js

(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const ref = urlParams.get('ref');
  const pid = urlParams.get('pid');
  const utmSource = urlParams.get('utm_source');

  const trackingKeys = {
    goaffpro: ['ref', 'dcode', 'source', 'gfp_v_id', 'gfp_ref_expires', 'sitestripe'],
    shareasale: ['sas_m_awin', 'trackb'],
    katalys: ['katalys_tracking', 'katalys_session', '_landing_page']
  };

  function clearTracking(keys, label) {
    keys.forEach(key => {
      // Clear cookie
      document.cookie = `${key}=; Path=/; Domain=.mitra-9.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      // Clear localStorage
      try {
        localStorage.removeItem(key);
      } catch (e) {}
    });
    console.log(`[Attribution] Cleared tracking for ${label}:`, keys);
  }

  let currentSource = null;

  if (ref) {
    currentSource = 'goaffpro';
  } else if (pid) {
    currentSource = 'shareasale';
  } else if (utmSource && utmSource.toLowerCase().includes('katalys')) {
    currentSource = 'katalys';
  }

  if (currentSource) {
    console.log(`[Attribution] Current source detected: ${currentSource}`);
    Object.keys(trackingKeys).forEach(source => {
      if (source !== currentSource) {
        clearTracking(trackingKeys[source], source);
      }
    });
  } else {
    console.log('[Attribution] No affiliate source detected in URL.');
  }
})();
